<cax-navigation
    *ngIf="location.pathname !== '/login' && location.pathname !== '/'"
    [header]="'Taxonomy Management (Beta)'"
    [expanded]="toggleNav"
    [topNavList]="topNavList"
    (onToggleNavigation)="onToggleNavigation($event)"
    [notifications]="false"
    [helpCentre]="true"
    (onHelpCentreClick)="openHelpManual()"
    [activeTab]="activeTab | async"
    [copyrightYear]="2025"
    [userName]="this.userData?.username"
    [version]="'Beta'"
    [profile]="false"
    [settings]="false"
    [userRole]="this.userData?.groups?.[0]"
    (onLogoutClick)="onLogoutClick()"></cax-navigation>

<div class="main-content" [ngClass]="{ expanded: toggleNav }">
    <router-outlet></router-outlet>
</div>
